import React from 'react';
import { Text } from '@mantine/core';

function UserManagement() {
  return (
    <div>
      <Text size="xl">User Management</Text>
    </div>
  );
}

export default UserManagement;
